/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { useEffect } from "react";
import Geo from "../components/Geo/Geo";
import { useSelector, useDispatch } from "react-redux";
import { checkAuthentication } from "./../../store/actions";
import {
  fetchGeofence,
  fetchUsers,
  fetchContractors,
} from "./../../store/actions";

const GeoWrapper = () => {
  const dispatch = useDispatch();
  const isSignedIn = useSelector((state) => state.auth.isSignedIn);

  useEffect(() => {
    dispatch(checkAuthentication());
  }, []);

  useEffect(() => {
    if (isSignedIn) {
      dispatch(fetchGeofence());
      dispatch(fetchUsers());
      dispatch(fetchContractors());
    }
  }, [isSignedIn]);

  return <Geo />;
};

export default GeoWrapper;
